import React, { useEffect, useState } from "react";
import axios from "axios";

interface Funcionario {
  id: number;
  nomecompleto: string;
  nascimento: string;
  cargo: string;
  dataadmissao: string;
  datainicialferias: string;
  datafinalferias: string;
  statusfuncionario: string;
  observacoes: string;
}

interface FuncionarioRF {
  id: number;
  nomecompleto: string;
  salario: string;
  comissao: string;
  fgts: string;
  inss: string;
  valealimentacao: string;
  valetransporte: string;
  horasextras: string;
  impostorenda: string;
  dataregistro: string;
  createdAt: string;
  updatedAt: string;
}

export const InfoLatealFuncionariosComponent = () => {
  const [adicionandoFuncionario, setAdicionandoFuncionario] = useState(true);
  const [dataIndividualRP, setDataIndividualRP] = useState();
  const [allDataRP, setAllDataRP] = useState([]);
  const [allDataRF, setAllDataRF] = useState<FuncionarioRF[]>([]);
  const [meses, setMeses] = useState();
  const [funcionarioAtual, setFuncionarioAtual] = useState<Funcionario>();
  const [funcionarioAtualRF, setFuncionarioAtualRF] = useState<FuncionarioRF>();

  const [nomeCompleto, setNomeCompleto] = useState("");
  const [nascimento, setNascimento] = useState("");
  const [cargo, setCargo] = useState("");
  const [dataAdmissao, setDataAdmissao] = useState("");
  const [dataInicialFerias, setDataInicialFerias] = useState("");
  const [dataFinalFerias, setDataFinalFerias] = useState("");
  const [statusFuncionario, setStatusFuncionario] = useState("");
  const [observacoes, setObservacoes] = useState("");

  const [id, setId] = useState<number>();
  const [salario, setSalario] = useState<number>();
  const [fgts, setFgts] = useState<number>();
  const [valeTransporte, setValeTransporte] = useState<number>();
  const [valeAlimentacao, setValeAlimentacao] = useState<number>();
  const [comissao, setComissao] = useState<number>();
  const [inss, setInss] = useState<number>();
  const [funcionarioSelecionado, setFuncionarioSelecionado] = useState();
  const [dataRegistro, setDataRegistro] = useState<string>("");
  const [horasExtras, setHorasExtras] = useState<number>();
  const [impostoRenda, setImpostoRenda] = useState<number>();
  const [dataEmpresa, setDataEmpresa] = useState(
    localStorage.getItem("dataEmpresa")
  );
  // Função para buscar os dados de todos os funcionários
  const getAllDataRP = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallfuncionariosrp`
      );
      setAllDataRP(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    }
  };

  const getAllDataRF = async () => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getallfuncionariosrf`
      );
      setAllDataRF(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    }
  };

  const getOneDataRP = async (id: any) => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getonefuncionariosrp/` + id
      );
      setNomeCompleto(response.data.nomecompleto);
      setNascimento(response.data.nascimento);
      setCargo(response.data.cargo);
      setDataAdmissao(response.data.dataadmissao);
      setDataInicialFerias(response.data.datainicialferias);
      setDataFinalFerias(response.data.datafinalferias);
      setStatusFuncionario(response.data.statusfuncionario);
      setObservacoes(response.data.observacoes);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    }
  };

  const getOneDataRF = async (id: any) => {
    try {
      const response = await axios.get(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/getonefuncionariosrf/` + id
      );

      setSalario(response.data.salario);
      setFgts(response.data.fgts);
      setValeTransporte(response.data.valetransporte);
      setValeAlimentacao(response.data.valealimentacao);
      setComissao(response.data.comissao);
      setInss(response.data.inss);
      setNomeCompleto(response.data.nomecompleto);
      setDataRegistro(response.data.dataregistro);
      setHorasExtras(response.data.horasextras);
      setImpostoRenda(response.data.impostorenda);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    }
  };
  


  const postAllDataRP = async () => {
    try {
      await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postfuncionariorp`, {
        nomecompleto: nomeCompleto,
        nascimento: nascimento || null,
        cargo: cargo,
        dataadmissao: dataAdmissao || null,
        datainicialferias: dataInicialFerias || null,
        datafinalferias: dataFinalFerias || null,
        statusfuncionario: statusFuncionario,
        observacoes: observacoes,
      });
  
      alert("Adicionado com sucesso!");
      // Limpar os campos após o cadastro
      setNomeCompleto("");
      setNascimento("");
      setCargo("");
      setDataAdmissao("");
      setDataInicialFerias("");
      setDataFinalFerias("");
      setStatusFuncionario("");
      setObservacoes("");
      // Atualizar a lista de funcionários
      getAllDataRP();
    } catch (error) {
      console.error("Erro ao adicionar funcionário:", error);
      alert("Erro ao adicionar funcionário. Por favor, tente novamente.");
    }
  };
  
  

  


  const postAllDataRF = async () => {
    await axios.post(`https://financeiro.api.protmar.com.br/${dataEmpresa}/postfuncionariorf`, {
      salario: salario,
      //fgts: fgts,
      valetransporte: valeTransporte,
      valealimentacao: valeAlimentacao,
      comissao: comissao,
      //inss: inss,
      nomecompleto: funcionarioSelecionado,
      dataregistro: Date.now(),
      horasextras: horasExtras,
      //impostorenda: impostoRenda,
    });

    alert("Adicionado Com Sucesso!");
    getAllDataRF();
  };

  useEffect(() => {
    getAllDataRP();
    getAllDataRF();
  }, []);

  const deletefuncionariorp = async () => {
    const confirmar = window.confirm(
      "Tem certeza que deseja excluir este funcionário?"
    );

    if (confirmar) {
      if (funcionarioAtual) {
        await axios.delete(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/deletefuncionariorp/` +
            funcionarioAtual.id
        );
        alert("Excluído com sucesso!");
        getAllDataRP();
      }
    } else {
      alert("Exclusão cancelada.");
    }
  };

  const deletefuncionariorf = async () => {
    const confirmar = window.confirm(
      "Tem certeza que deseja excluir este funcionário?"
    );

    if (confirmar) {
      if (funcionarioAtualRF) {
        await axios.delete(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/deletefuncionariorf/` +
            funcionarioAtualRF.id
        );
        alert("Excluído com sucesso!");
        getAllDataRF();
      }
    } else {
      alert("Exclusão cancelada.");
    }
  };
  
  const putAllDataRP = async () => {
    try {
      if (funcionarioAtual) {
        await axios.put(
          `https://financeiro.api.protmar.com.br/${dataEmpresa}/putfuncionariorp/` +
            funcionarioAtual.id,
          {
            nomecompleto: nomeCompleto,
            nascimento: nascimento,
            cargo: cargo,
            dataadmissao: dataAdmissao,
            datainicialferias: dataInicialFerias,
            datafinalferias: dataFinalFerias,
            statusfuncionario: statusFuncionario,
            observacoes: observacoes,
          }
        );

        getAllDataRP();
        alert("Funcionario atualizado com sucesso!");
      }
    } catch (error) {
      console.log("Campos Incompletos");
      alert("Campos Incompletos");
    }
  };

  const putAllDataRF = async () => {
    if (funcionarioAtualRF) {
      await axios.put(
        `https://financeiro.api.protmar.com.br/${dataEmpresa}/putfuncionariorf/` +
          funcionarioAtualRF.id,
        {
          salario: salario,
          //fgts: fgts,
          valetransporte: valeTransporte,
          valealimentacao: valeAlimentacao,
          comissao: comissao,
          //inss: inss,
          nomecompleto: funcionarioSelecionado,
          dataregistro: Date.now(),
          horasextras: horasExtras,
          //impostorenda: impostoRenda,
        }
      );

      getAllDataRF();
      alert("Funcionario atualizado com sucesso!");
    }
  };

  return (
    <div
      id="IFCMain"
      style={{
        width: "98%",
        position: "absolute",
        top: "80px",
      }}
    >
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        onClick={() => {
          setNomeCompleto("");
          setNascimento("");
          setCargo("");
          setDataAdmissao("");
          setDataInicialFerias("");
          setDataFinalFerias("");
          setStatusFuncionario("");
          setObservacoes("");
        }}
      >
        Adicionar Novo Funcionario
      </button>

      <div
        style={{ maxHeight: "200px", overflowY: "auto" }}
        className="table-responsive"
      >
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Cargo</th>
              <th scope="col">Salario</th>
              <th scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            {allDataRP && allDataRP.length > 0 ? (
              allDataRP.map((e: any) => (
                <tr key={e.id}>
                  <td>{e.nomecompleto}</td>
                  <td>{e.cargo}</td>
                  <td>{e.salario ? `R$ ${e.salario}` : "Não informado"}</td>
                  <td>
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => {
                        getOneDataRP(e.id);
                        setFuncionarioAtual(e);
                      }}
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4}>Nenhum funcionário encontrado</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Registro Pessoal
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h4>Informações do Funcionário</h4>

                <table className="table">
                  <tr>
                    <td>
                      {" "}
                      <label className="form-label">Nome Completo</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e: any) => setNomeCompleto(e.target.value)}
                        value={nomeCompleto}
                      />
                    </td>
                    <td>
                      <label className="form-label">Data de Nascimento</label>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e: any) => setNascimento(e.target.value)}
                        value={nascimento}
                      />
                    </td>
                    <td>
                      <label className="form-label">Cargo</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(e: any) => setCargo(e.target.value)}
                        value={cargo}
                      />
                    </td>
                    <td>
                      <label className="form-label">Data de Admissão</label>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e: any) => setDataAdmissao(e.target.value)}
                        value={dataAdmissao}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <label className="form-label">
                        Data Prevista Inicial Férias
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e: any) =>
                          setDataInicialFerias(e.target.value)
                        }
                        value={dataInicialFerias}
                      />
                    </td>
                    <td>
                      <label className="form-label">
                        Data Prevista Final Férias
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e: any) =>
                          setDataFinalFerias(e.target.value)
                        }
                        value={dataFinalFerias}
                      />
                    </td>
                    <td>
                      {" "}
                      <label className="form-label">
                        Status do Funcionário
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onChange={(e: any) =>
                          setStatusFuncionario(e.target.value)
                        }
                        value={statusFuncionario}
                      >
                        <option selected>Selecione o Status</option>
                        <option value="Ativo">Ativo</option>
                        <option value="Afastado">Afastado</option>
                        <option value="Aviso Previo">Aviso Prévio</option>
                        <option value="Demitido">Demitido</option>
                      </select>
                    </td>
                    <td>
                      <label className="form-label">Observações</label>
                      <textarea
                        onChange={(e: any) => setObservacoes(e.target.value)}
                        value={observacoes}
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows={3}
                      ></textarea>
                    </td>
                  </tr>
                </table>
              </div>

              <hr />
            </div>
            <div className="modal-footer">
              <button onClick={deletefuncionariorp} className="btn btn-danger">
                Excluir
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Fechar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  funcionarioAtual ? putAllDataRP() : postAllDataRP();
                }}
              >
                Salvar Dados
              </button>
            </div>
          </div>
        </div>
      </div>

      {
        //////////////////////////////////////////////////////////////////////////////////////////////////////
      }
      <hr />
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal2"
        onClick={() => {
          setSalario(0);
          setFgts(0);
          setValeTransporte(0);
          setValeAlimentacao(0);
          setComissao(0);
          setInss(0);
          setNomeCompleto("");
          setDataRegistro("");
          setHorasExtras(0);
          setImpostoRenda(0);
        }}
      >
        Nova Entrada Financeira
      </button>

      <div
        className="modal fade"
        id="exampleModal2"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Registro Financeiro
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div>
                <h4>Informações do Funcionário</h4>

                <table className="table">
                  <tr>
                    <td>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onChange={(e: any) => {
                          setFuncionarioSelecionado(e.target.value);
                        }}
                      >
                        <option selected>Selecione o Funcionario</option>
                        {allDataRP && allDataRP.length > 0 ? (
                          allDataRP.map((e: any) => (
                            <option value={e.nomecompleto}>
                              {e.nomecompleto}
                            </option>
                          ))
                        ) : (
                          <option value="none">
                            Nem um Funcionario Encontrado
                          </option>
                        )}
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label className="form-label">Salario</label>
                      <input
                        onChange={(e: any) => setSalario(e.target.value)}
                        value={salario}
                        type="number"
                        className="form-control"
                      />
                    </td>

                    <td>
                      <label className="form-label">Vale Transporte</label>
                      <input
                        onChange={(e: any) => setValeTransporte(e.target.value)}
                        value={valeTransporte}
                        type="number"
                        className="form-control"
                      />
                    </td>
                    <td>
                      <label className="form-label">Vale Alimentação</label>
                      <input
                        onChange={(e: any) =>
                          setValeAlimentacao(e.target.value)
                        }
                        value={valeAlimentacao}
                        type="number"
                        className="form-control"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <label className="form-label">Comissões</label>
                      <input
                        onChange={(e: any) => setComissao(e.target.value)}
                        value={comissao}
                        type="number"
                        className="form-control"
                      />
                    </td>

                    <td>
                      {" "}
                      <label className="form-label">Horas Extras</label>
                      <input
                        onChange={(e: any) => setHorasExtras(e.target.value)}
                        value={horasExtras}
                        type="number"
                        className="form-control"
                      />
                    </td>
                  </tr>
                </table>
              </div>

              <hr />
            </div>
            <div className="modal-footer">
              <button onClick={deletefuncionariorf} className="btn btn-danger">
                Excluir
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Fechar
              </button>
              <button
                onClick={() => {
                  funcionarioAtual ? putAllDataRF() : postAllDataRF();
                }}
                type="button"
                className="btn btn-primary"
              >
                Salvar Dados
              </button>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div>
        <br />
        <input
          type="month"
          onChange={(e: any) => {
            setMeses(e.target.value);
          }}
        />
        {allDataRF && allDataRF.length > 0 && meses ? (
          <table className="table table-striped">
            <thead>
              <tr>
                <th colSpan={4}>{meses}</th> {/* Nome do mês selecionado */}
              </tr>
              <tr>
                <th>Nome Completo</th>
                <th>Salário</th>
                <th>Comissão</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {allDataRF
                .filter((e) => e.dataregistro.slice(0, 7) === meses) // Filtra os dados que correspondem ao mês
                .map((e, index) => (
                  <tr key={index}>
                    <td>{e.nomecompleto}</td>
                    <td>R$ {e.salario}</td>
                    <td>R$ {e.comissao}</td>
                    <td>
                      <button
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal2"
                        className="btn btn-warning"
                        onClick={() => {
                          getOneDataRF(e.id);
                          setFuncionarioAtualRF(e);
                        }}
                      >
                        Visualizar
                      </button>
                    </td>
                  </tr>
                ))}
              {allDataRF.filter((e) => e.dataregistro.slice(0, 7) === meses)
                .length === 0 && ( // Caso não haja registros para o mês selecionado
                <tr>
                  <td colSpan={4}>
                    Nenhum registro encontrado para o mês selecionado
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          <p>Por favor, selecione um mês para visualizar os registros.</p> // Mensagem caso não haja dados ou mês selecionado
        )}
      </div>
    </div>
  );
};
